(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("frack-components"), require("classnames"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "frack-components", "classnames"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("frack-components"), require("classnames")) : factory(root["react"], root["frack-components"], root["classnames"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__13__) {
return 